module.exports = (parcelRequire.load("9QLCT")).then(() => parcelRequire('jW7Dw'));